module.exports = __webpack_public_path__ + "static/media/brand-refresh-Wheelchair.166f4483.svg";